export var isSoundCloudUrl = function isSoundCloudUrl(url) {
  var regexp = /^https?:\/\/(soundcloud\.com|snd\.sc)\/(.*)$/;
  return url.match(regexp) && url.match(regexp)[2];
};
export var hasIframeTag = function hasIframeTag(value) {
  return value.match('(?:<iframe[^>]*)(?:(?:>)|(?:>.*?<iframe>))');
};
export default {};